import { useEffect, useState } from "react";
import Joi from "joi-browser";

export default useWebhookTriggerConfigForm;

export const webhookTriggerConfigSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow(null, "").label("Description"),
  payloadMapping: Joi.array().min(1).label("Mapping"),
};

export const getWebhookTriggerConfigureData = (webhookTriggerConfig) => {
  const { name, description, payloadMapping } = webhookTriggerConfig;

  return {
    name,
    description,
    payloadMapping,
  };
};

function useWebhookTriggerConfigForm(
  webhookTriggerConfig,
  validationErrors = {},
) {
  const [formState, setFormState] = useState(() =>
    getWebhookTriggerConfigureData(webhookTriggerConfig),
  );
  const [errors, setErrors] = useState(validationErrors);

  useEffect(() => {
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(webhookTriggerConfigSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });
    setErrors(fieldErrors);
    return false;
  };

  return { formState, validate, updateFormState, errors };
}
